// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"645":"2490750a","747":"ec9b25bb"}[chunkId] + ".css";
};